import {UserSession} from "../model/session/user-session";
import {Injectable} from "@angular/core";
import {AppConfigurationClient} from "@azure/app-configuration";
import {GlobalConstants} from "../global-constants";
import {Router} from "@angular/router";
import {EnvService} from "../../env-service/env.service";
import {Observable} from "rxjs";
import {environment} from "@environment";
import {HttpClient} from "@angular/common/http";
import {FeatureFlag} from "../model/feature-flag";


@Injectable()
export class UserSessionService {

    private userSession: UserSession;

    constructor(private envService: EnvService,
                private router: Router, private http: HttpClient) {
        this.userSession = new UserSession();
    }

    get data(): UserSession { return this.userSession; }

    timeoutSession(){
        this.clearSession();
        this.userSession.sessionTimedOut = true;
        this.userSession.sessionEnded = true;
    }

    getFeatureFlag(flagName: string): Observable<FeatureFlag> {
      const url = environment.getApiUrl(environment.featureFlagUrl(flagName),
        this.envService.mhsApiEndpoint,
        this.envService.apiSubscriptionId);
      return this.http.get<FeatureFlag>(url);
    }
    clearSession(){
        //clear the session but keep the companyId & dataTheme
        let companyId = this.userSession.companyId;
        let dataTheme = this.userSession.dataTheme;
        this.userSession = new UserSession();
        this.userSession.companyId = companyId;
        this.userSession.dataTheme = dataTheme;
    }

    public setRequiredPhysicianFlag(key: string, answer: string){
        if(answer.trim() == 'no'){
          if(this.data.physicianRequiredQuestions.includes(key)){//remove the key from the array
            this.removeDocument(key);
          }
        } else if(answer.trim() == 'yes'){
          if(this.data.physicianRequiredQuestions == undefined){
            let physicianRequiredQuestions: string[] = [];
            physicianRequiredQuestions.push(key);
            this.data.physicianRequiredQuestions = physicianRequiredQuestions;
          } else {
            if(this.data.physicianRequiredQuestions.includes(key)){
              //do nothing
            } else {
              let physicianRequiredQuestions = this.data.physicianRequiredQuestions;
              physicianRequiredQuestions.push(key);
              this.data.physicianRequiredQuestions = physicianRequiredQuestions;
            }
          }
        }
        this.setPhysicianFlag();
    }

    private removeDocument(doc){
        this.data.physicianRequiredQuestions.forEach( (item, index) => {
            if(item === doc) this.data.physicianRequiredQuestions.splice(index,1);
        });
    }

    private setPhysicianFlag(){
        if(this.data.physicianRequiredQuestions.length > 0){
          this.data.answeredYesToRequiredPhysicianQuestion = true;
        }
        else{
          this.data.answeredYesToRequiredPhysicianQuestion = false;
        }
    }

    async checkForSnyEnabled() {

      const sny_enable_status = this.getFeatureFlag(GlobalConstants.enableSnyKey);

      return sny_enable_status.toPromise().then((response: FeatureFlag) => {
        return response.enabled;
      }).catch((error) => {
        return false;
      });

  }

    async checkForSystemMaintenance() {

        try {
          const maintenance_status = this.getFeatureFlag(GlobalConstants.maintenanceKey);
          maintenance_status.toPromise().then((response: FeatureFlag) => {;
            let isMaintenancePageEnabled = response.enabled;
            if (isMaintenancePageEnabled) {
              this.data.maintenance_mode = true
              this.data.maintenance_time = response.description
              this.router.navigate(['maintenance']);
              return true;
            } else if (response.description != '') {
              this.data.maintenance_mode = false
              this.data.maintenance_time = response.description
              return true;
            } else {
              this.data.maintenance_mode = false
              this.data.maintenance_time = ''
              return false;
            }
          }).catch((error) => {
            return false;
          });
        } catch(error){
          return false;
        }
    }

}
